import { Injectable } from '@angular/core';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { InputSearchStorageKeys } from '@nimbus-library/features/shared/components/material/input-search/input-search-storage-keys.enum';

@Injectable({ providedIn: 'root' })
export class InputSearchStorageKeysService {
  public constructor(private readonly authenticationService: IAuthenticationService) {}

  public getLocalStorageKey(storageKey: InputSearchStorageKeys | undefined): string | null {
    if (!storageKey) {
      return null;
    }

    const userName = this.authenticationService.getUserInfo()?.userName || '';
    return `Nimbus.User.${userName}.InputSearch.${storageKey}`;
  }
}
